import React, { Component } from "react";
import { connect } from 'react-redux';
import { FormGroup, ControlLabel, FormControl, Row, Col } from "react-bootstrap";

class HorizontalFormInputs extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange = event => {
    // this.setState({title: eventKey});
    this.props.onValueChange(event.target.value,this.props.statekey, this.props.eth);
  };
  render() {
    const {label, status, ncols, hidden, ...rest} = this.props;
    let statusStyle = '';
    if(status === "disconnected"){
      statusStyle = "statusColorDisconnected"
    }
    else if(status === "connected"){
      statusStyle = "statusColorConnected";
    }
    var row = [];
    var style = {};
    if(hidden===true) {
      style.display = 'none';
    }

    for (var i = 0; i < ncols.length; i++) {
      row.push(
        <div key={i} className={ncols[i]}>
          <FormGroup style={{ marginBottom: -10 + "px" }}>
            <Col componentClass={ControlLabel} style={{ marginTop: 5 + "px" }} md={5}>
              {label}
            </Col>
            <Col md={7}>
              <FormControl className={statusStyle} style={{ height: 25 + "px"}} onChange={this.onChange} {...rest} />
            </Col>
          </FormGroup>

        </div>
      );
    }
    return <div style={style}>{row}</div>;
  }
}

export default HorizontalFormInputs;
